"use strict";

// getPageScroll() by quirksmode.org
// Finds the scroll position of a page
module.exports = function () {
    var xScroll, yScroll;
    if (self.pageYOffset) {
        yScroll = self.pageYOffset;
        xScroll = self.pageXOffset;
    } else if (document.documentElement && document.documentElement.scrollTop) {
        yScroll = document.documentElement.scrollTop;
        xScroll = document.documentElement.scrollLeft;
    } else if (document.body) {
        // all other Explorers
        yScroll = document.body.scrollTop;
        xScroll = document.body.scrollLeft;
    }
    return [xScroll, yScroll];
};




/*****************
 ** WEBPACK FOOTER
 ** ./~/dom-find/getPageScroll.js
 ** module id = 317
 ** module chunks = 1
 **/